import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { BrowserPaintService } from '../services/browser-paint.service';
import { ResizeObserverService } from '../services/resize-observer.service';

@Directive({
    selector: '[ohpResize]'
})
export class ResizeDirective implements AfterViewInit, OnInit, OnDestroy {
    @Output('ohpResize') public readonly resize = new EventEmitter<DOMRectReadOnly>();

    private resizeObserver: ResizeObserver;

    constructor(
        private readonly resizeObserverService: ResizeObserverService,
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly browserPaintService: BrowserPaintService
    ) {
    }

    public ngOnInit() {
        this.resizeObserver = this.resizeObserverService.createAndObserve(entries => this.onResize(entries[0]), this.elementRef.nativeElement);
    }

    public ngAfterViewInit() {
        // This will emit the current size on component initialization.
        this.browserPaintService.runAfterPaint(() => {
            this.resize.emit(this.elementRef.nativeElement.getBoundingClientRect() as DOMRectReadOnly);
        });
    }

    public ngOnDestroy() {
        this.resizeObserver.disconnect();
    }

    private onResize(entry: ResizeObserverEntry) {
        if (!entry) {
            return;
        }

        this.resize.emit(entry.contentRect as DOMRectReadOnly);
    }
}
